import { ChannelViewClinicPetParentFragment } from 'shared/types/graphql';
import { selectPrimaryPhoneNumberBestGuess } from 'shared/utils';

const getIsAllPetParentsReachableBySms = (clinicPetParents: ChannelViewClinicPetParentFragment[]): boolean => {
  const petParentsWithoutPhone = clinicPetParents.filter(
    ({ phoneNumbers }) => !selectPrimaryPhoneNumberBestGuess(phoneNumbers || []),
  );
  const petParentsWithSmsDisabled = clinicPetParents.filter(
    ({ petParentSetting }) => !petParentSetting?.smsNotifications,
  );
  return !Boolean(petParentsWithoutPhone.length) && !Boolean(petParentsWithSmsDisabled.length);
};

export default getIsAllPetParentsReachableBySms;
